import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  resources: any;
  videolinks: any;

  constructor(
    private httpClient: HttpClient,
    private Config: Config,
    private cookieService: CookieService
  ) {
    this.getResources();
    this.getVideoLinks();
  }

  projectsList(token: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token,
    });
    // console.log('token in service file', token);
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/project`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateActivity(activity: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
      'Access-Control-Request-Method': 'POST',
      'Access-Control-Request-Headers': 'X-Custom-Header',
    };
    const body = activity;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/updateActivity`,
        body,
        { headers }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // updateActivity1(activity:any) {

  //   var request = {
  //     method: "POST",
  //     url: appConst.request.activityLog.url,
  //     headers: {
  //       'authorization': window.localStorage.getItem("publicToken"),
  //       'Content-Type': 'application/json',
  //       'Access-Control-Request-Method': 'POST',
  //       'Access-Control-Request-Headers': 'X-Custom-Header'
  //     },
  //     data: activity
  //   };
  //   return $http(request);
  // }

  getResources() {
    this.loadResources().subscribe((response: any) => {
      // console.log('response loadResources success', response[0]);
      this.resources = response[0];
    });
  }

  getVideoLinks() {
    this.loadVideoLinks().subscribe((response: any) => {
      // console.log('response loadVideoLinks success', response[0]);
      this.videolinks = response[0];
    });
  }

  loadResources() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/resource/`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  loadVideoLinks() {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    // console.log('loadVideoLinks called');
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/videolink/`,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // getCookie(cname) {
  //   var name = cname + "=";
  //   var decodedCookie = decodeURIComponent(document.cookie);
  //   var ca = decodedCookie.split(';');
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == ' ') {
  //       c = c.substring(1);
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length);
  //     }
  //   }
  //   return "";
  // }

  getResourceText(id: any) {
    var lang = this.cookieService.get('language').slice(0, 2);
    return this.resources.value[lang][id]
      ? this.resources.value[lang][id].text
      : '';
  }

  getVideoURL(id: any) {
    // console.log("Lan",this.cookieService.get('language'));
    var lang = this.cookieService.get('language').slice(0, 2);
    var lang = 'en';
    // console.log("this.videolinks",this.videolinks,lang,id);
    return this.videolinks.value[lang][id]
      ? this.videolinks.value[lang][id].URL
      : '';
  }

  // api to get all notifications
  getAllNotifications(skipcount: any, registeredDetails: any) {
    let params = new HttpParams();
    params = params.append('skip', skipcount);
    params = params.append('registeredOn', registeredDetails);
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    return this.httpClient
      .get(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/listAllEnterpriseNotifications`,
        { headers: header, params: params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getNotifications(sessionDetails: any) {
    let header = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    });
    const body = sessionDetails;
    return this.httpClient
      .post(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/getNotificationsCount`,
        body,
        { headers: header }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
